export const LogoMark = ({ size = 34, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <g className="spin-slow">
        <path d="M32 8 A24 24 0 0 1 54 22" />
        <path d="M56 34 A24 24 0 0 1 40 54.6" />
        <path d="M24 54.6 A24 24 0 0 1 8.4 36" />
        <path d="M9.5 24 A24 24 0 0 1 24 9.4" />
      </g>
      <path d="M18 17 L46 17 L32 32 Z" />
      <path d="M32 32 L46 47 L18 47 Z" />
    </g>
    <circle cx="32" cy="32" r="3" fill="var(--signal)" />
  </svg>
);
